import React, { useState, useEffect } from 'react';
import { RefreshCw } from 'lucide-react';
import { Button } from './ui/button';
import api from '../lib/api';

export const UpdateBanner = () => {
    const [updateAvailable, setUpdateAvailable] = useState(false);
    const [currentVersion, setCurrentVersion] = useState(null);
    const [debugInfo, setDebugInfo] = useState('');

    useEffect(() => {
        const checkVersion = async () => {
            try {
                const res = await api.get('/deploy-version');
                const serverVersion = res.data.version;
                const storedVersion = localStorage.getItem('app_version');
                
                setDebugInfo(`Server: ${serverVersion}, Stored: ${storedVersion || 'none'}`);
                
                if (!storedVersion) {
                    // First load - store version
                    localStorage.setItem('app_version', serverVersion);
                    setCurrentVersion(serverVersion);
                } else if (storedVersion !== serverVersion) {
                    // Version changed - show banner
                    setUpdateAvailable(true);
                    setCurrentVersion(serverVersion);
                }
            } catch {
                // Silent version check error
            }
        };

        // Check immediately
        checkVersion();

        // Check every 30 seconds
        const interval = setInterval(checkVersion, 30000);

        return () => clearInterval(interval);
    }, []);

    const handleRefresh = () => {
        localStorage.setItem('app_version', currentVersion);
        window.location.reload();
    };

    if (!updateAvailable) return null;

    return (
        <div className="fixed top-0 left-0 right-0 z-50 bg-primary text-primary-foreground py-3 px-4 flex items-center justify-center gap-3 shadow-lg">
            <RefreshCw className="h-5 w-5" />
            <span className="font-medium">Neue Version verfügbar!</span>
            <Button 
                size="sm" 
                variant="secondary"
                onClick={handleRefresh}
            >
                Jetzt aktualisieren
            </Button>
        </div>
    );
};

export default UpdateBanner;
